export const PolicyInfo = [
    [
        {
            label: "产品线",
            type: "text",
            value: "software_name",
            span: 6
        },
        {
            label: "产品名称",
            type: "text",
            value: "product_name",
            span: 6
        },
        {
            label: "文本类型",
            type: "text",
            value: "text_type",
            span: 6
        },
        {
            label: "区域",
            type: "text",
            value: "area",
            span: 6
        }
    ],
    [
        {
            label: "产品线",
            type: "link",
            value: "software_name",
            span: 6
        },
        {
            label: "产品",
            type: "link",
            value: "product_name",
            span: 6
        },
        {
            label: "申请人",
            type: "text",
            value: "apply_uid",
            span: 6
        },
        {
            label: "申请时间",
            type: "text",
            value: "apply_time",
            span: 6
        }
    ],
    [
        {
            label: "部署人",
            type: "text",
            value: "deployer",
            span: 6
        },
        {
            label: "部署时间",
            type: "text",
            value: "deploy_time",
            span: 6
        },
        {
            label: "下一版本生效时间",
            type: "text",
            value: "next_version_effective_time",
            span: 6
        },
        {
            label: "审批编号",
            type: "link",
            value: "approval_id",
            span: 6
        }
    ],
    [
        {
            label: "版本号",
            type: "text",
            value: "version_number",
            span: 6
        },
        {
            label: "最新修改人",
            type: "text",
            value: "edit_user",
            span: 6
        },
        {
            label: "最新修改时间",
            type: "text",
            value: "edit_time",
            span: 6
        },
        {
            label: "经办人",
            type: "text",
            value: "director",
            span: 6
        }
    ],
    [
        {
            label: "隐私政策链接",
            type: "link",
            value: "link",
            span: 6
        },
        {
            label: "是否多端共用",
            type: "text_splice",
            value: "using_platform",
            span: 6
        }
    ]
]
